import { render } from "./CadastroEngenheiro.vue?vue&type=template&id=0a88e5cd"
import script from "./CadastroEngenheiro.vue?vue&type=script&lang=ts"
export * from "./CadastroEngenheiro.vue?vue&type=script&lang=ts"
script.render = render

export default script